import { createApiCall } from 'lib/base';

const REVOKE_SUBSCRIPTION_USER = 'REVOKE_SUBSCRIPTION_USER';

const revokeSubscriptionUserApi = createApiCall<{ id: string; userId: string }>(
  REVOKE_SUBSCRIPTION_USER,
  ({ id, userId }) => ({
    endpoint: `api/admin/subscriptions/${id}/users/${userId}/revoke`,
    method: 'POST',
  })
);

export default revokeSubscriptionUserApi;
